<div>
  <button *ngIf="!showGraph3d" mat-icon-button (click)="goBackFunc()" style="
    text-align: left;
    position: absolute;
    left: 27px;
    z-index: 9;
    top: 85px;">
    <mat-icon>arrow_back</mat-icon>
    <span style="
    margin-left: 6px;">Regresar</span>
  </button>
  <div *ngIf="showGraph3d">
    <app-force-graph [nodes]="nodes" [links]="links" (volver)="toggleGraph()"></app-force-graph>
  </div>
  <div>
    <app-neovis style="margin-top:20px;" (nodesAndLinks)="onNodesAndLinks($event)" [element]="element"></app-neovis>
  </div>
  <button mat-button class="toggle-button btn btn-info" (click)="toggleGraph()"
    style="background: #110c2a !important;">3D</button>
</div>